import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=320610cc&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=320610cc&prod&lang=css"
import style1 from "./Item.vue?vue&type=style&index=1&id=320610cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320610cc",
  null
  
)

export default component.exports